import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class AdminBundleListController extends Controller {
  connect() {
    this.handleSortingBundlePackageList()
  }

  handleSortingBundlePackageList() {
    const group = this.element.dataset.group
    const sortable = Sortable.create(this.element, {
      sort: true,
      draggable: '.bundle-package'
    })
    sortable.option("filter", ".head-row")
    sortable.option("onUpdate", () => {
      fetch("/admin/bundle_package_positions", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({
          group: group,
          new_position_ids: getNewPositionIds()
        })
      })
      .then(resp => {
        if (!resp.ok) {
          throw new Error("Something went wrong while updating the position")
        }
      })
    })

    function getNewPositionIds() {
      return sortable.toArray()
    }
  }
}
